export default {
    assign_firmware_title: "Assign Firmware",
    assign_firmware_the_device_is_already_added: "The device is already added",
    assign_firmware_the_hardware_version_of_the_device_mustbe_the_same: "The hardware version of the devices must be the same",
    assign_firmware_the_manufacturer_of_the_device_must_be_vidfleet: "The manufacturer of the device must be VidFleet",
    assign_firmware_no_device_found: "No device found",
    assign_firmware_serial: "Serial",
    assign_firmware_device_name: "Device Name",
    assign_firmware_model: "Model",
    assign_firmware_label: "Firmware",
    assign_firmware_error_firmware_currently: "The version of the new firmware must be higher than the one currently assigned to the devices",
    assign_firmware_error_firmware_different: "The version of the new firmware must be different from the one currently assigned to the devices",
    assign_firmware_hardware_version: "Hardware Version",
    assign_firmware_the_firmware_has_been_updated: "The firmware has been updated",
    assign_firmware_firmware_upgrade_not_posible: "Firmware upgrade not possible",
    assign_firmware_outdated: "Outdated",
    assign_firmware_firmware_refresh_cameras: "Refresh cameras firmware",
    assign_firmware_firmware_cameras_updated: "Firmware cameras updated",
    assign_firmware_updated: "Updated",
    assign_firmware_device_model: "Device Model",
    assign_firmware_devices: "Devices",
    assign_firmware_no_data: "No devices to configure",
    assign_firmware_select_firmware: "Select a Firmware",
    assign_firmware_new_Firmware: "New Firmware",
    assign_firmware_all_devices: "All Devices",
    assign_firmware_label_all_devices: "The changes will be applied to all devices in the account",
    assign_firmware_no_firmwares: "There is no firmwares available for",
    assign_firmware_not_specified: "Not Specified",
}